<section class="dark">
    <div class="contained">
        <div class="_breadcrumbs">
            <div class="_breadcrumb" *ngFor="let breadcrumb of breadcrumbs">
                <a [routerLink]="breadcrumb.route" [title]="breadcrumb.title">{{ breadcrumb.title }}</a>
            </div>
        </div>
    </div>
</section>
